import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { store } from "../../app/interviewStore";
import { DeadStateScreen } from "Modules/Interview/InterviewTheme/InterviewComponents/DeadStateScreen";
import { INTERVIEW_STATUS } from "Modules/Interview/constants";

const InvalidInterviewLink = () => {
    const [cssFile, setCssFile] = useState("");
    useEffect(() => {
        fetch("/build/interview/interview-theme/rev-manifest.json", {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (myJson) {
                console.log("/" + myJson["interview.css"]);
                setCssFile("/interview/interview-theme/" + myJson["interview.css"]);
            });
    },[])
    return (
        <div style={{height: '100vh', textAlign: 'center'}} >
            <Provider store={store}>
                <link rel="stylesheet" type="text/css" href={cssFile}  />
                <DeadStateScreen status={INTERVIEW_STATUS.INVALID_LINK} />
            </Provider>
        </div>
    );
};

export default InvalidInterviewLink;